<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
export let filename = '';
</script>

<div class="filename-clip">
    <div class="filename-clip-icon-container">
        <svg xmlns="http://www.w3.org/2000/svg"
             fill="none"
             viewBox="0 0 24 24"
             stroke-width="2"
             stroke="currentColor"
             class="clip-icon">
            <path stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21.44 11.05l-9.19 9.19a5 5 0 11-7.07-7.07l9.19-9.19a3 3 0 014.24 4.24l-9.19 9.19a1 1 0 11-1.41-1.41l9.19-9.19"/>
        </svg>
    </div>
    {filename}
</div>

<style>
    .filename-clip {
        display: inline-flex;
        align-items: center;
    }

    .clip-icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
        color: #555;
        margin-right: 5px;
        margin-top: -5px;
    }

    .clip-icon:hover {
        color: #000;
    }
</style>